module.exports = __webpack_public_path__ + "img/13-min.fa41f215.jpg";